
import React from 'react';

interface BlurOverlayProps {
  children: React.ReactNode;
  className?: string;
}

const BlurOverlay = ({ children, className = "" }: BlurOverlayProps) => {
  return (
    <div className={`bg-white/80 backdrop-blur-md p-6 rounded-xl border border-white/20 shadow-lg ${className}`}>
      {children}
    </div>
  );
};

export default BlurOverlay;
